import { DebugMenuExtension } from "./debug-menu";
import { TextTypeMenuExtension } from "./text-type-menu";
import { InlineInsertMenu } from "./inline-insert-menu";
import { LinkEditBoxExtension } from "./link-edit-box";
import { ToDoListItemExtension } from "./to-do-list-items";
import { StrikethroughMarkExtension } from "./strikethrough";
import { LocalFilesExtension } from "./local-files";
import { BusinessEntitiesExtension } from "./mystekz-business-entities";
import { RolesExtension } from "./mystekz-roles";
import { DomainsExtension } from "./mystekz-domains";
import { ProcessesExtension } from "./mystekz-processes";
import { ProductsExtension } from "./mystekz-products";
import { MermaidExtension } from "./mermaid";
import { CodeLanguagesExtension } from "./code-languages";
import { LinkPreviewExtension } from "./link-preview";

export const ExtensionMap = {
    "mystekz-business-entities": () => new BusinessEntitiesExtension(),
    "debug-menu": () => new DebugMenuExtension(),
    "mystekz-domains": () => new DomainsExtension(),
    "inline-insert-menu": () => new InlineInsertMenu(),
    "link-edit-box": () => new LinkEditBoxExtension(),
    "local-files": () => new LocalFilesExtension(),
    "mystekz-processes": () => new ProcessesExtension(),
    "mystekz-products": () => new ProductsExtension(),
    "mystekz-roles": () => new RolesExtension(),
    "strikethrough": () => new StrikethroughMarkExtension(),
    "text-type-menu": () => new TextTypeMenuExtension(),
    "to-do-list-items": () => new ToDoListItemExtension(),
    "mermaid": () => new MermaidExtension(),
    "code-languages": () => new CodeLanguagesExtension(),
    "link-preview": () => new LinkPreviewExtension(),
};

export type ExtensionKeys = keyof typeof ExtensionMap;
